import Modal from "./Modal";
import modalStyles from "./Modal.module.css";
export {modalStyles};
export default Modal;
